import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { GraphNavigationService } from '@app/registration/graph/graph-navigation.service';
import { HCTX_PARAM_KEY } from '@app/registration/routing/constants';
import { NavbarHeaderComponent } from '@app/shared/navbar-header/navbar-header.component';
import { SharedModule } from '@app/shared/shared.module';

@Component({
  selector: 'om-mfa',
  templateUrl: './mfa.component.html',
  standalone: true,
  imports: [NavbarHeaderComponent, SharedModule],
})
export class MfaComponent implements OnInit {
  protected percentComplete: number | null = null;

  constructor(private graphNavigationService: GraphNavigationService, private route: ActivatedRoute) {}

  ngOnInit(): void {
    if (this.graphNavigationService.navigationInProgress) {
      this.percentComplete = this.graphNavigationService.percentComplete;
    }
  }

  onSubmit() {
    // pass through health context query param if found
    const hctx = this.route.snapshot.queryParams[HCTX_PARAM_KEY];
    this.graphNavigationService.navigate({ ...(hctx && { hctx }) });
  }
}
